import { PostHogConfig } from 'posthog-js'

export interface PostHogOptions {
	api_key: string
	options: Partial<PostHogConfig>
}

export const postHogConfig: PostHogOptions = {
	api_key: import.meta.env.VITE_POSTHOG_API_KEY,
	options: {
		debug: import.meta.env.VITE_ENVIRONMENT === 'development',
		api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://b.jobilla.com',
		ui_host: import.meta.env.VITE_POSTHOG_UI_HOST || 'https://eu.posthog.com',
		person_profiles: 'identified_only',
		autocapture: true,
		opt_in_site_apps: true,
	},
}
